

const Grid = ({children}) => {
    return (
        <div className="grid-content">
            {children}
        </div>
    )
}

export default Grid;